import React, { useEffect } from 'react';

import Accordion from '../../Accordion';
import { useAccordionState } from '../../Accordion/AccordionProvider';

import Indicator from './_Indicator';
import FAQItemContent from './_FAQItemContent';

/**
 * Types
 */

export interface Props {
  openedIndex: number;
  question: string;
  answer: string;
  setOpenedIndex: React.Dispatch<number>;
  index: number;
}

/**
 * Component
 */

export default function AccordionContent({ index, question, answer, setOpenedIndex, openedIndex }: Props) {
  const { open, setOpen } = useAccordionState();

  useEffect(() => {
    if (open) setOpenedIndex(index);
  }, [index, open, setOpenedIndex]);

  useEffect(() => {
    setOpen(openedIndex === index);
  }, [setOpen, openedIndex, index]);

  return (
    <>
      <Accordion.Title
        classes="text-site-neutrals-700 site-paragraph-xl gap-4 mr-4"
        indicatorPosition="right"
        indicatorCollapsed={<Indicator iconName="ExpandMore" />}
        indicatorExpanded={<Indicator iconName="ExpandLess" />}
        justify="between"
      >
        <p>{question}</p>
      </Accordion.Title>

      <Accordion.Content classes="text-site-neutrals-500 site-paragraph-m mt-6 mr-10">
        <FAQItemContent answer={answer} />
      </Accordion.Content>
    </>
  );
}
